export enum SupportType {
  ADMINISTRATIVE = "ADMINISTRATIVE",
  FINANCIAL = "FINANCIAL",
  PORTAL = "PORTAL",
  COMMERCIAL = "COMMERCIAL",
  TECHNICAL = "TECHNICAL",
  CONTRACT_CANCELLATION = "CONTRACT_CANCELLATION",
}

export const typesSupportOccorence = {
  TECHNICAL_SUPPORT: "intl-msg:tas.support.toolbar.supportType.technical",
  VOLKSTOTAL: "intl-msg:tas.support.toolbar.supportType.volkstotal",
};

export const typesOcorrenceStatus = {
  OPEN: "Pendente de análise",
  IN_ANALYSIS: "Em análise VWCO",
  ANSWERED: "Respondido ao Dealer",
  FINISHED: "Finalizado",
};

export const typesOcorrenceStatusIds = {
  OPEN: "intl-msg:tas.occurrence.card.open",
  IN_ANALYSIS: "intl-msg:tas.occurrence.card.inAnalysis",
  ANSWERED: "intl-msg:support.constants.statusAnsweredDealer",
  FINISHED: "intl-msg:tas.occurrence.card.finished",
};

export const typeStatusOccurence = [
  { labelId: "intl-msg:tas.occurrence.card.open", id: "OPEN" },
  { labelId: "intl-msg:tas.occurrence.card.inAnalysis", id: "IN_ANALYSIS" },
  { labelId: "intl-msg:tas.occurrence.card.answered", id: "ANSWERED" },
  { labelId: "intl-card:tas.finished.title", id: "FINISHED" },
];

export const typeSubjectOccorence = {
  ADMINISTRATIVE: "Administrativo",
  FINANCIAL: "Financeiro",
  PORTAL: "Portal VolksTotal",
  COMMERCIAL: "Comercial",
  TECHNICAL: "Técnico",
  CONTRACT_CANCELLATION: "Cancelamento de contrato",
  CABIN: "01. Cabine (Acabamentos, Bancos, climatizador, Geladeira e A/C)",
  GEARBOX: "02. Caixa de mudanças / mecanismo de seleção e engate",
  CHASSIS: "03. Chassi (Componentes ligados)",
  SUPPORT_AXLE: "04. Eixo de apoio (truck)",
  FRONT_AXLE: "05. Eixo dianteiro / 2º eixo direcional",
  CLUTCH: "06. Embreagem (incluindo sistema de acionamento)",
  ENGINE: "07. Motor (veículo diesel)",
  E_DELIVERY: "08. E-Delivery",
  WHEEL: "09. Roda (retentor / cubo / rolamento)",
  STEERING_SYSTEM: "10. Sistema de direção",
  EXHAUST_SYSTEM_AND_AFTER_TREATMENT:
    "11. Sistema de exaustão e pós tratamento",
  BRAKE_SYSTEM: "12. Sistema de freios e circuito pneumático",
  ELECTRICAL_SYSTEM: "13. Sistema elétrico (veículo diesel)",
  DRIVE_AXLE: "14. Eixo trativo (diferencial)",
  SUSPENSION: "15. Suspensão",
  POWER_TAKEOFF: "16. Tomada de força",
  TRANSMISSION: "17. Transmissão (cruzeta, semi-árvores, cardan)",
  SOFTWARE_DIESEL_VEHICLE: "18. Software (Veículo Diesel)",
  ENGINE_REPLACEMENT_REQUEST: "19. Solicitação de troca do motor",
  SOFTWARE_IDLE_AUTO_SHUTDOWN:
    "20. Software - AT 011-26-Desligamento automático por tempo em marcha lenta",
  TAS_DIAGNOSIS_TOOLS: "TAS - 2. Ferramentas de diagnose",
};

export const typeSubjectOccorenceIds = {
  ADMINISTRATIVE: "intl-msg:support.constants.subject.administrative",
  FINANCIAL: "intl-msg:support.constants.subject.financial",
  PORTAL: "intl-msg:support.constants.subject.portal",
  COMMERCIAL: "intl-msg:support.constants.subject.commercial",
  TECHNICAL: "intl-msg:support.constants.subject.technical",
  CONTRACT_CANCELLATION: "intl-msg:support.constants.subject.contractCancellation",
  CABIN: "intl-msg:support.constants.subject.cabin",
  GEARBOX: "intl-msg:support.constants.subject.gearbox",
  CHASSIS: "intl-msg:support.constants.subject.chassis",
  SUPPORT_AXLE: "intl-msg:support.constants.subject.supportAxle",
  FRONT_AXLE: "intl-msg:support.constants.subject.frontAxle",
  CLUTCH: "intl-msg:support.constants.subject.clutch",
  ENGINE: "intl-msg:support.constants.subject.engine",
  E_DELIVERY: "intl-msg:support.constants.subject.eDelivery",
  WHEEL: "intl-msg:support.constants.subject.wheel",
  STEERING_SYSTEM: "intl-msg:support.constants.subject.steeringSystem",
  EXHAUST_SYSTEM_AND_AFTER_TREATMENT: "intl-msg:support.constants.subject.exhaustSystemAndAfterTreatment",
  BRAKE_SYSTEM: "intl-msg:support.constants.subject.brakeSystem",
  ELECTRICAL_SYSTEM: "intl-msg:support.constants.subject.electricalSystem",
  DRIVE_AXLE: "intl-msg:support.constants.subject.driveAxle",
  SUSPENSION: "intl-msg:support.constants.subject.suspension",
  POWER_TAKEOFF: "intl-msg:support.constants.subject.powerTakeoff",
  TRANSMISSION: "intl-msg:support.constants.subject.transmission",
  SOFTWARE_DIESEL_VEHICLE: "intl-msg:support.constants.subject.softwareDieselVehicle",
  ENGINE_REPLACEMENT_REQUEST: "intl-msg:support.constants.subject.engineReplacementRequest",
  SOFTWARE_IDLE_AUTO_SHUTDOWN: "intl-msg:support.constants.subject.softwareIdleAutoShutdown",
  TAS_DIAGNOSIS_TOOLS: "intl-msg:support.constants.subject.tasDiagnosisTools",
};

export const subTopicSupport = {
  MANUAL_CONTRACT_REGISTRATION: "Cadastro manual de contrato / aditamento",
  INVOICE_REQUEST: "Solicitação de boletos / notas fiscais",
  REGISTRATION_CHANGE_REQUEST: "Solicitação de alteração de cadastro",
  CONTRACT_DUE_DATE_CHANGE: "Alteração de data de vencimento do contrato",
  CONTRACT_BLOCKED_AUTHORIZATION:
    "Contrato bloqueado / autorização de atendimento",
  INVOICE_CANCELLATION: "Cancelamento de nota fiscal",
  BILLING_QUESTIONS: "Dúvida referente a cobrança (valores / regras)",
  CONTRACT_RENEGOTIATION: "Renegociação de contrato",
  CONTRACT_STATUS_CONSULTATION: "Consulta Status do contrato",
  BOLETO_AMOUNT_UPDATE:
    "Atualização do valor de cobrança do boleto (pós vencimento)",
  KM_HOUR_MEASUREMENT: "Aferição de km / hora",
  VOLKS_TOTAL_PORTAL_ACCESS: "Acesso ao portal Volks|Total",
  GENERAL_QUESTIONS: "Dúvidas gerais",
  COMMERCIAL: "Comercial",
  REQUEST: "Solicitação",
  CONTRACT_EXTENSION_RENEWAL: "aditamento/renovação",
  REPAIR_AUTHORIZATION: "Autorização de reparo",
  PARTS_COVERAGE: "Cobertura de peças",
  TECHNICAL_QUESTION: "Dúvida técnica",
  CHASSIS_REPAIR_HISTORY: "Histórico do chassi / reparo",
  LATE_REVIEW_TOLERANCE: "Revisão fora do prazo (tolerância)",
  COMPLEMENTARY_OPERATIONS: "Operações complementares",
  REVIEW_CHECKLIST_ITEMS: "Itens do checklist de revisão",
  REGISTRATION_AND_CONTRACT_VERIFICATION:
    "Verificação de cadastro / ativação de contratos / aditamento",
  PROMOTIONAL_PLAN_ACTIVATION: "Ativação de Plano Promocional",
  CONTRACT_STATUS_INQUIRY: "Consulta de status do contrato",
  BLOCKED_CONTRACT_SERVICE_AUTHORIZATION:
    "Contrato bloqueado - autorização de atendimento",
  INVOICE_DUE_DATE_CHANGE:
    "Alteração de data de vencimento do boleto",
  OPEN_CHARGES_RENEGOTIATION:
    "Renegociação de cobranças em aberto",
  INVOICE_AND_NF_ISSUANCE: "Emissão de boleto / NF",
  PARTS_COVERAGE_QUESTION:
    "Dúvida sobre cobertura de peças",
  REVISION_CHECKLIST_QUESTION:
    "Dúvidas sobre checklist de revisão",
  MAINTENANCE_AND_COMPLEMENTARY_SERVICES_HISTORY:
    "Histórico de manutenção / serviços complementares",
  TRUCKER_ASSIST_REGISTRATION: "Cadastro Trucker Assist",
};

export const subTopicSupportIds = {
  MANUAL_CONTRACT_REGISTRATION: "intl-msg:support.constants.subtopic.manualContractRegistration",
  INVOICE_REQUEST: "intl-msg:support.constants.subtopic.invoiceRequest",
  REGISTRATION_CHANGE_REQUEST: "intl-msg:support.constants.subtopic.registrationChangeRequest",
  CONTRACT_DUE_DATE_CHANGE: "intl-msg:support.constants.subtopic.contractDueDateChange",
  CONTRACT_BLOCKED_AUTHORIZATION: "intl-msg:support.constants.subtopic.contractBlockedAuthorization",
  INVOICE_CANCELLATION: "intl-msg:support.constants.subtopic.invoiceCancellation",
  BILLING_QUESTIONS: "intl-msg:support.constants.subtopic.billingQuestions",
  CONTRACT_RENEGOTIATION: "intl-msg:support.constants.subtopic.contractRenegotiation",
  CONTRACT_STATUS_CONSULTATION: "intl-msg:support.constants.subtopic.contractStatusConsultation",
  BOLETO_AMOUNT_UPDATE: "intl-msg:support.constants.subtopic.boletoAmountUpdate",
  KM_HOUR_MEASUREMENT: "intl-msg:support.constants.subtopic.kmHourMeasurement",
  VOLKS_TOTAL_PORTAL_ACCESS: "intl-msg:support.constants.subtopic.volksTotalPortalAccess",
  GENERAL_QUESTIONS: "intl-msg:support.constants.subtopic.generalQuestions",
  COMMERCIAL: "intl-msg:support.constants.subject.commercial",
  REQUEST: "intl-msg:support.constants.subtopic.request",
  CONTRACT_EXTENSION_RENEWAL: "intl-msg:support.constants.subtopic.contractExtensionRenewal",
  REPAIR_AUTHORIZATION: "intl-msg:support.constants.subtopic.repairAuthorization",
  PARTS_COVERAGE: "intl-msg:support.constants.subtopic.partsCoverage",
  TECHNICAL_QUESTION: "intl-msg:support.constants.subtopic.technicalQuestion",
  CHASSIS_REPAIR_HISTORY: "intl-msg:support.constants.subtopic.chassisRepairHistory",
  LATE_REVIEW_TOLERANCE: "intl-msg:support.constants.subtopic.lateReviewTolerance",
  COMPLEMENTARY_OPERATIONS: "intl-msg:support.constants.subtopic.complementaryOperations",
  REVIEW_CHECKLIST_ITEMS: "intl-msg:support.constants.subtopic.reviewChecklistItems",
  REGISTRATION_AND_CONTRACT_VERIFICATION: "intl-msg:support.constants.subtopic.registrationAndContractVerification",
  PROMOTIONAL_PLAN_ACTIVATION: "intl-msg:support.constants.subtopic.promotionalPlanActivation",
  CONTRACT_STATUS_INQUIRY: "intl-msg:support.constants.subtopic.contractStatusInquiry",
  BLOCKED_CONTRACT_SERVICE_AUTHORIZATION: "intl-msg:support.constants.subtopic.blockedContractServiceAuthorization",
  INVOICE_DUE_DATE_CHANGE: "intl-msg:support.constants.subtopic.invoiceDueDateChange",
  OPEN_CHARGES_RENEGOTIATION: "intl-msg:support.constants.subtopic.openChargesRenegotiation",
  INVOICE_AND_NF_ISSUANCE: "intl-msg:support.constants.subtopic.invoiceAndNfIssuance",
  PARTS_COVERAGE_QUESTION: "intl-msg:support.constants.subtopic.partsCoverageQuestion",
  REVISION_CHECKLIST_QUESTION: "intl-msg:support.constants.subtopic.revisionChecklistQuestion",
  MAINTENANCE_AND_COMPLEMENTARY_SERVICES_HISTORY: "intl-msg:support.constants.subtopic.maintenanceAndComplementaryServicesHistory",
  TRUCKER_ASSIST_REGISTRATION: "intl-msg:support.constants.subtopic.truckerAssistRegistration",
};

export const optionsAdministrative = [
  {
    id: "TRUCKER_ASSIST_REGISTRATION",
    label: "Cadastro Trucker Assist",
    labelId: "intl-msg:support.constants.subtopic.truckerAssistRegistration",
  },
  {
    id: "REGISTRATION_AND_CONTRACT_VERIFICATION",
    label: "Verificação de cadastro / ativação de contratos / aditamento",
    labelId: "intl-msg:support.constants.subtopic.registrationAndContractVerification",
  },
  {
    id: "PROMOTIONAL_PLAN_ACTIVATION",
    label: "Ativação de Plano Promocional",
    labelId: "intl-msg:support.constants.subtopic.promotionalPlanActivation",
  },
  {
    id: "CONTRACT_STATUS_INQUIRY",
    label: "Consulta de status do contrato",
    labelId: "intl-msg:support.constants.subtopic.contractStatusInquiry",
  },
  {
    id: "BLOCKED_CONTRACT_SERVICE_AUTHORIZATION",
    label: "Contrato bloqueado - autorização de atendimento",
    labelId: "intl-msg:support.constants.subtopic.blockedContractServiceAuthorization",
  },
  {
    id: "REGISTRATION_CHANGE_REQUEST",
    label: "Solicitação de alteração de cadastro",
    labelId: "intl-msg:support.constants.subtopic.registrationChangeRequest",
  },
];

export const optionsFinancial = [
  {
    id: "INVOICE_DUE_DATE_CHANGE",
    label: "Alteração de data de vencimento do boleto",
    labelId: "intl-msg:support.constants.subtopic.invoiceDueDateChange",
  },
  {
    id: "BOLETO_AMOUNT_UPDATE",
    label: "Atualização do valor de cobrança do boleto (pós vencimento)",
    labelId: "intl-msg:support.constants.subtopic.boletoAmountUpdate",
  },
  {
    id: "INVOICE_CANCELLATION",
    label: "Cancelamento de nota fiscal",
    labelId: "intl-msg:support.constants.subtopic.invoiceCancellation",
  },
  {
    id: "BILLING_QUESTIONS",
    label: "Dúvida referente a cobrança (valores / regras)",
    labelId: "intl-msg:support.constants.subtopic.billingQuestions",
  },
  {
    id: "OPEN_CHARGES_RENEGOTIATION",
    label: "Renegociação de cobranças em aberto",
    labelId: "intl-msg:support.constants.subtopic.openChargesRenegotiation",
  },
  {
    id: "INVOICE_AND_NF_ISSUANCE",
    label: "Emissão de boleto / NF",
    labelId: "intl-msg:support.constants.subtopic.invoiceAndNfIssuance",
  },
];

export const optionsVolksTotalPortal = [
  {
    id: "KM_HOUR_MEASUREMENT",
    label: "Aferição de km / hora",
    labelId: "intl-msg:support.constants.subtopic.kmHourMeasurement",
  },
  {
    id: "VOLKS_TOTAL_PORTAL_ACCESS",
    label: "Acesso ao portal VolksTotal",
    labelId: "intl-msg:support.constants.subtopicOption.volksTotalPortalAccess",
  },
  {
    id: "GENERAL_QUESTIONS",
    label: "Dúvidas gerais",
    labelId: "intl-msg:support.constants.subtopic.generalQuestions",
  },
];

export const optionsTechnical = [
  {
    id: "REPAIR_AUTHORIZATION",
    label: "Autorização de reparo",
    labelId: "intl-msg:support.constants.subtopic.repairAuthorization",
  },
  {
    id: "PARTS_COVERAGE_QUESTION",
    label: "Dúvida sobre cobertura de peças",
    labelId: "intl-msg:support.constants.subtopic.partsCoverageQuestion",
  },
  {
    id: "TECHNICAL_QUESTION",
    label: "Dúvida técnica",
    labelId: "intl-msg:support.constants.subtopic.technicalQuestion",
  },
  {
    id: "REVISION_CHECKLIST_QUESTION",
    label: "Dúvidas sobre checklist de revisão",
    labelId: "intl-msg:support.constants.subtopic.revisionChecklistQuestion",
  },
  {
    id: "MAINTENANCE_AND_COMPLEMENTARY_SERVICES_HISTORY",
    label: "Histórico de manutenção / serviços complementares",
    labelId: "intl-msg:support.constants.subtopic.maintenanceAndComplementaryServicesHistory",
  },
  {
    id: "LATE_REVIEW_TOLERANCE",
    label: "Revisão fora do prazo (tolerância)",
    labelId: "intl-msg:support.constants.subtopic.lateReviewTolerance",
  },
];

export const getSupportSubtopicLabelId = (subtopic?: string) => {
  if (!subtopic) {
    return undefined;
  }

  const selectOption = [
    ...optionsAdministrative,
    ...optionsFinancial,
    ...optionsVolksTotalPortal,
    ...optionsTechnical,
  ].find((option) => option.id === subtopic);

  if (selectOption) {
    return selectOption.labelId;
  }

  return subTopicSupportIds[subtopic as keyof typeof subTopicSupportIds];
};

export const supportSubjectOptions = [
  {
    id: "CABIN",
    label: "01. Cabine (Acabamentos, Bancos, climatizador, Geladeira e A/C)",
    labelId: "intl-msg:support.constants.subject.cabin",
  },
  {
    id: "GEARBOX",
    label: "02. Caixa de mudanças / mecanismo de seleção e engate",
    labelId: "intl-msg:support.constants.subject.gearbox",
  },
  {
    id: "CHASSIS",
    label: "03. Chassi (Componentes ligados)",
    labelId: "intl-msg:support.constants.subject.chassis",
  },
  {
    id: "SUPPORT_AXLE",
    label: "04. Eixo de apoio (truck)",
    labelId: "intl-msg:support.constants.subject.supportAxle",
  },
  {
    id: "FRONT_AXLE",
    label: "05. Eixo dianteiro / 2º eixo direcional",
    labelId: "intl-msg:support.constants.subject.frontAxle",
  },
  {
    id: "CLUTCH",
    label: "06. Embreagem (incluindo sistema de acionamento)",
    labelId: "intl-msg:support.constants.subject.clutch",
  },
  {
    id: "ENGINE",
    label: "07. Motor (veículo diesel)",
    labelId: "intl-msg:support.constants.subject.engine",
  },
  {
    id: "E_DELIVERY",
    label: "08. E-Delivery",
    labelId: "intl-msg:support.constants.subject.eDelivery",
  },
  {
    id: "WHEEL",
    label: "09. Roda (retentor / cubo / rolamento)",
    labelId: "intl-msg:support.constants.subject.wheel",
  },
  {
    id: "STEERING_SYSTEM",
    label: "10. Sistema de direção",
    labelId: "intl-msg:support.constants.subject.steeringSystem",
  },
  {
    id: "EXHAUST_SYSTEM_AND_AFTER_TREATMENT",
    label: "11. Sistema de exaustão e pós tratamento",
    labelId: "intl-msg:support.constants.subject.exhaustSystemAndAfterTreatment",
  },
  {
    id: "BRAKE_SYSTEM",
    label: "12. Sistema de freios e circuito pneumático",
    labelId: "intl-msg:support.constants.subject.brakeSystem",
  },
  {
    id: "ELECTRICAL_SYSTEM",
    label: "13. Sistema elétrico (veículo diesel)",
    labelId: "intl-msg:support.constants.subject.electricalSystem",
  },
  {
    id: "DRIVE_AXLE",
    label: "14. Eixo trativo (diferencial)",
    labelId: "intl-msg:support.constants.subject.driveAxle",
  },
  {
    id: "SUSPENSION",
    label: "15. Suspensão",
    labelId: "intl-msg:support.constants.subject.suspension",
  },
  {
    id: "POWER_TAKEOFF",
    label: "16. Tomada de força",
    labelId: "intl-msg:support.constants.subject.powerTakeoff",
  },
  {
    id: "TRANSMISSION",
    label: "17. Transmissão (cruzeta, semi-árvores, cardan)",
    labelId: "intl-msg:support.constants.subject.transmission",
  },
  {
    id: "SOFTWARE_DIESEL_VEHICLE",
    label: "18. Software (Veículo Diesel)",
    labelId: "intl-msg:support.constants.subject.softwareDieselVehicle",
  },
  {
    id: "ENGINE_REPLACEMENT_REQUEST",
    label: "19. Solicitação de troca do motor",
    labelId: "intl-msg:support.constants.subject.engineReplacementRequest",
  },
  {
    id: "SOFTWARE_IDLE_AUTO_SHUTDOWN",
    label: "20. Software - AT 011-26-Desligamento automático por tempo em marcha lenta",
    labelId: "intl-msg:support.constants.subject.softwareIdleAutoShutdown",
  },
  {
    id: "TAS_DIAGNOSIS_TOOLS",
    label: "TAS - 2. Ferramentas de diagnose",
    labelId: "intl-msg:support.constants.subject.tasDiagnosisTools",
  },
];

export const supportStatusOptions = [
  { id: "ADMINISTRATIVE", label: "Administrativo", labelId: "intl-msg:support.constants.subject.administrative" },
  { id: "FINANCIAL", label: "Financeiro", labelId: "intl-msg:support.constants.subject.financial" },
  { id: "PORTAL", label: "Portal VolksTotal", labelId: "intl-msg:support.constants.subject.portal" },
  // { id: "COMMERCIAL", label: "Comercial" },
  { id: "TECHNICAL", label: "Técnico", labelId: "intl-msg:support.constants.subject.technical" },
  { id: "CONTRACT_CANCELLATION", label: "Cancelamento de contrato", labelId: "intl-msg:support.constants.subject.contractCancellation" },
];

export const F2_FORM_SUBJECTS = [
  "GEARBOX",
  "CHASSIS",
  "SUPPORT_AXLE",
  "FRONT_AXLE",
  "CLUTCH",
  "ENGINE",
  "E_DELIVERY",
  "WHEEL",
  "STEERING_SYSTEM",
  "BRAKE_SYSTEM",
  "ELECTRICAL_SYSTEM",
  "DRIVE_AXLE",
  "SUSPENSION",
  "POWER_TAKEOFF",
  "TRANSMISSION",
];

export const INPUTS_NAME = {
  id: "",
  tasOccurrence: "",
  tasOccurrenceNumber: "intl-msg:support.constants.field.contractNumber",
  supportType: "intl-msg:tas.support.toolbar.supportType",
  responsible: "",
  assignedTo: "intl-msg:support.constants.field.assignedTo",
  assignedToId: "intl-msg:support.constants.field.assignedTo",
  chassis: "intl-msg:support.constants.field.chassis",
  licensePlate: "intl-msg:tas.occurrence.licensePlate",
  dn: "intl-msg:tas.support.toolbar.dn",
  dnResponsible: "intl-msg:support.constants.field.dnResponsible",
  phone: "intl-msg:support.constants.field.phone",
  customer: "intl-msg:support.constants.field.customer",
  createdBy: "intl-msg:support.constants.field.createdBy",
  hourMeter: "intl-msg:tas.occurrence.hourMeter",
  odometer: "intl-msg:support.constants.field.odometer",
  entryDate: "intl-msg:support.constants.field.entryDate",
  createdAt: "intl-msg:support.constants.field.createdAt",
  updatedAt: "intl-msg:support.constants.field.updatedAt",
  statusUpdatedAt: "",
  subject: "intl-msg:support.subject",
  details: "intl-msg:support.constants.field.details",
  partName: "intl-msg:support.constants.field.partName",
  aeg: "intl-msg:support.constants.field.aeg",
  customerComment: "intl-msg:support.constants.field.customerComment",
  diagnose: "intl-msg:support.constants.field.diagnose",
  repair: "intl-msg:support.constants.field.repair",
  analysisReason: "intl-msg:support.constants.field.analysisReason",
  contractNumber: "",
  vehicleQtd: "intl-msg:support.constants.field.vehicleQtd",
  cancelReason: "intl-msg:support.constants.field.cancelReason",
  cancelComment: "intl-msg:support.constants.field.cancelComment",
  status: "intl-msg:tas.occurrence.step",
  timeInStatus: "intl-msg:tas.support.toolbar.sort.stepTime",
  subtopic: "intl-msg:support.constants.field.subtopic",
  partOrComponentName: "intl-msg:support.constants.field.partOrComponentName",
  partNumber: "intl-msg:support.constants.field.partNumber",
  problemDescription: "intl-msg:support.constants.field.problemDescription",
  diagnosticAndResults: "intl-msg:support.constants.field.diagnosticAndResults",
  problemSteps: "intl-msg:support.constants.field.problemSteps",
  failureFrequency: "intl-msg:support.constants.field.failureFrequency",
  failCodes: "intl-msg:support.constants.field.relatedFaultCodes",
  observations: "intl-msg:support.constants.field.observations",
  comment: 'intl-msg:support.constants.field.comment'
};

export const ACTIONS_NAME = {
  'UPDATE': 'intl-msg:support.constants.action.update',
  'CREATE': 'intl-msg:support.constants.action.create',
  'DELETE': 'intl-msg:support.constants.action.delete'
}

export const GroupsMatriz = {
  '6cf126dd-8753-4b31-a2de-fc11f223e471': 'crc',
  'b0aaec78-6d1b-4778-b6db-49b1bfda21d8': 'Backoffice',
  '8c564d38-1d8f-4b27-8613-80cf6482f0f8': 'gestores-aprovadores' 
}

export const optionsGroupsMatriz = [
  {
      id: '6cf126dd-8753-4b31-a2de-fc11f223e471',
      label: 'crc',
  },
  {
      id: 'b0aaec78-6d1b-4778-b6db-49b1bfda21d8',
      label: 'backoffice',
  },
  {
      id: '8c564d38-1d8f-4b27-8613-80cf6482f0f8',
      label: 'gestores-aprovadores',
  },
];


export const fieldLabelsSubject = {
  responsible: 'Responsável',
  dn: 'Dn',
  chassis: 'Chassi do veículo',
  licensePlate: 'Placa do veículo',
  dnResponsible: 'Responsável pelo chamado no DN',
  phone: 'Tel para contato',
  customer: 'Nome do cliente',
  regionalId: 'Regional',
  hourMeter: 'Horímetro',
  odometer: 'Km',
  entryDate: 'Data de entrada do veículo',
  customerComment: 'Detalhe da solicitação ou Qual a reclamação do cliente?',
  partName: 'Nome da peça causadora',
  aeg: 'N° AEG',
  diagnose: 'Diagnóstico / causa da falha',
  repair: 'Reparo necessário',
  analysisReason: 'Motivo do envio para análise',
  contractNumber: 'Número do contrato',
  vehicleQtd: 'Quantidade de veículos',
  cancelReason: 'Motivo do cancelamento',
  cancelComment: 'Descrever a solicitação',
  partOrComponentName: 'Nome da Peça ou Componente',
  partNumber: 'N° da peça VW/MAN',
  problemDescription: 'O que aconteceu?',
  problemSteps: 'É possível reproduzir? Informe o passo-a-passo.',
  diagnosticAndResults: 'Relate procedimentos de diagnóstico e resultados',
  failureFrequency: 'Em qual frequência a falha ocorre?'
};

export const fieldOptionsSubject = [
  { field: 'responsible', required: false },
  { field: 'dn', required: false },
  { field: 'chassis', required: false },
  { field: 'licensePlate', required: false },
  { field: 'dnResponsible', required: false },
  { field: 'phone', required: false },
  { field: 'customer', required: false },
  { field: 'regionalId', required: false },
  { field: 'hourMeter', required: false },
  { field: 'odometer', required: false },
  { field: 'entryDate', required: false },
  { field: 'customerComment', required: false },
  { field: 'partName', required: false },
  { field: 'aeg', required: false },
  { field: 'diagnose', required: false },
  { field: 'repair', required: false },
  { field: 'analysisReason', required: false },
  { field: 'contractNumber', required: false },
  { field: 'vehicleQtd', required: false },
  { field: 'cancelReason', required: false },
  { field: 'cancelComment', required: false },
  { field: 'partOrComponentName', required: false },
  { field: 'partNumber', required: false },
  { field: 'problemDescription', required: false },
  { field: 'problemSteps', required: false },
  { field: 'diagnosticAndResults', required: false },
  { field: 'failureFrequency', required: false },
];

export const SupportAssignmentFilter = {
  ASSIGNED: 'Chamados com atribuição',
  UNASSIGNED: 'Chamados sem atribuição',
  ALL: 'Todos os chamados',
}

export const SupportAssignmentFilterOptions = [{
  id: 'ASSIGNED',
  label: SupportAssignmentFilter.ASSIGNED,
},{
  id: 'UNASSIGNED',
  label: SupportAssignmentFilter.UNASSIGNED,
},{
  id: 'all',
  label: SupportAssignmentFilter.ALL,
}]

export const ASSIGNMENT_STATIC_IDS = ['ASSIGNED', 'UNASSIGNED', 'all'] as const;

export const isStaticAssignmentFilter = (id: string) =>
  ASSIGNMENT_STATIC_IDS.includes(id as (typeof ASSIGNMENT_STATIC_IDS)[number]);

export const resolveAssignmentSelection = (selected: string[], previous: string[]): string[] => {
  if (!selected.length) return ['all'];

  const newlyAdded = selected.filter((id) => !previous.includes(id));
  const lastAdded = newlyAdded[newlyAdded.length - 1] ?? selected[selected.length - 1];

  if (lastAdded === 'all') return ['all'];

  if (isStaticAssignmentFilter(lastAdded)) {
    return [lastAdded];
  }

  return selected.filter((id) => !isStaticAssignmentFilter(id));
};

export const assignmentSelectionToParams = (selection: string[]) => {
  const userIds = selection.filter((id) => !isStaticAssignmentFilter(id));

  if (userIds.length) {
    return { assigned: '', assignedToId: userIds.join(',') };
  }

  const staticFilter = selection[0] || 'all';

  if (staticFilter === 'all') {
    return { assigned: '', assignedToId: '' };
  }

  return { assigned: staticFilter, assignedToId: '' };
};

export const assignmentParamsToSelection = (assigned: string, assignedToId: string): string[] => {
  if (assignedToId) return assignedToId.split(',');
  if (assigned) return [assigned];
  return ['all'];
};
